import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license';
import './index.css';
import App from './App';

LicenseInfo.setLicenseKey('ebbe7f6491cd4121cc83b06422bae288Tz0xMjcyMDgsRT0xODA1NTAwNzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y');
	
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

